// Pro API - Team Management Operations
import { request } from "../base";
import type { TeamMember, TeamInvitation, ContactCheckResult } from "./types";

export const teamApi = {
	async getMembers(proId: string, includeInactive = false) {
		const query = includeInactive ? "?includeInactive=true" : "";
		return request<TeamMember[]>(`/api/pro/${proId}/team${query}`);
	},

	async addMember(
		proId: string,
		data: { email: string; role: "owner" | "manager" | "staff" },
	) {
		return request<TeamMember>(`/api/pro/${proId}/team`, {
			method: "POST",
			body: data,
		});
	},

	async updateMember(
		proId: string,
		roleId: number,
		data: { role: "manager" | "staff" },
	) {
		return request<TeamMember>(`/api/pro/${proId}/team/${roleId}`, {
			method: "PUT",
			body: data,
		});
	},

	async removeMember(proId: string, roleId: number) {
		return request(`/api/pro/${proId}/team/${roleId}`, {
			method: "DELETE",
		});
	},

	async deactivateMember(proId: string, roleId: number) {
		return request<TeamMember>(
			`/api/pro/${proId}/team/${roleId}/deactivate`,
			{ method: "POST" },
		);
	},

	async reactivateMember(proId: string, roleId: number) {
		return request<TeamMember>(
			`/api/pro/${proId}/team/${roleId}/reactivate`,
			{ method: "POST" },
		);
	},

	// Contact check (debounced pre-validation)
	async checkContact(
		proId: string,
		data: { email?: string; phone?: string },
	) {
		return request<ContactCheckResult>(`/api/pro/${proId}/team/check-contact`, {
			method: "POST",
			body: data,
		});
	},

	// Invitations
	async invite(
		proId: string,
		data: { email?: string; phone?: string; role: "owner" | "manager" | "staff" },
	) {
		return request<TeamInvitation>(`/api/pro/${proId}/team/invite`, {
			method: "POST",
			body: data,
		});
	},

	async getInvitations(proId: string) {
		return request<TeamInvitation[]>(
			`/api/pro/${proId}/team/invitations`,
		);
	},

	async resendInvitation(proId: string, invitationId: number) {
		return request(
			`/api/pro/${proId}/team/invitations/${invitationId}/resend`,
			{ method: "POST" },
		);
	},

	async cancelInvitation(proId: string, invitationId: number) {
		return request(`/api/pro/${proId}/team/invitations/${invitationId}`, {
			method: "DELETE",
		});
	},
};
